<template>
    <div v-if="$store.state.settings.activeTab === 'Settings_Position'">
        <v-row class="d-flex justify-center">
            <v-col cols="12" lg="10" xl="9">
                <Datatable :headers="tableHeaders" :items="positions" title="Positionen" :items-per-page="-1"
                           @click:row="emitClicked"
                           @click:edit="emitClicked"
                           @click:delete="emitClicked($event, true)"
                >
                    <template #top>
                        <Button v-if="$vuetify.breakpoint.mdAndUp" icon="mdi-plus"
                                :color="ada.blue" @click="emitClicked(null)">Position hinzufügen
                        </Button>
                    </template>
                </Datatable>
            </v-col>
        </v-row>
        <AddEditPositionDialog v-model="showDialog"></AddEditPositionDialog>
        <DeletePositionDialog v-model="showDeleteDialog"></DeletePositionDialog>
    </div>
</template>

<script>
import Datatable from "../../../components/Tables/Datatable";
import ada from "../../../scss/ada_colors.scss";
import Button from "../../../components/buttons/Button";
import Utils from "../../../scripts/Utils";
import AddEditPositionDialog from "../Dialogs/AddEditPositionDialog";
import DeletePositionDialog from "../../Settings/Dialogs/DeletePositionDialog";

export default {
    name: "Settings_Position",
    components: {DeletePositionDialog, AddEditPositionDialog, Button, Datatable},
    data: () => {
        return {
            tableHeaders: [
                {text: 'Bezeichnung', value: 'Name'},
                {text: 'Erstellt am', value: 'created_at', width: '250px'},
                {text: 'Aktion', value: 'action', width: '100px', sortable: false},
            ],
            showDialog: false,
            showDeleteDialog: false,
            ada
        }
    },
    computed: {
        vuexState() {
            return this.$store.state.settings;
        },
        positions() {
            let positions = this.vuexState.positions ? this.vuexState.positions : [];
            positions.forEach((item) => {
                item.created_at = Utils.formatDate(item.Created, true);
                item.action = ['edit', 'delete'];
            })
            return positions;
        }
    },
    methods: {
        emitClicked(item, deleting = false) {
            this.$emit('click', item, deleting, this);
        },
    },
}
</script>

<style scoped>

</style>